"use strict";
exports.__esModule = true;
exports.fontStyleItalic = { fontStyle: 'italic' };
exports.fontWeightNormal = { fontWeight: 'normal' };
exports.fontWeightBold = { fontWeight: 'bold' };



//////////////////
// WEBPACK FOOTER
// ./~/csstips/lib/font.js
// module id = 605
// module chunks = 0